module.exports = {
	// values to help ID this event hub in debugging. 
	name: 'UI Events',
	instance: Math.random()
};
